<template>
  <div class="section-box">
    <el-tabs v-model="selectTab" type="card" class="customer-tabs-mg" @tab-click="handleReset"
      :before-leave="tabSelect">
      <el-tab-pane v-for="(item, index) in tabArray" :label="item.value" :name="item.key + ''" :key="index"></el-tab-pane>
    </el-tabs>


    <div class="customer-list">
      <el-row class="customer-row-bg" style="padding: 3px;">
        <el-alert title="提示：" :closable="false" type="success">
          <slot>
            <p style="font-size: 14px;">每隔10分钟同步一次订单到此列表，每天凌晨2点推送前一天单子；</p>
            <p style="font-size: 14px;">阈值：单个工单不超过<span style="font-weight: bold;">￥{{ (ediConfig &&
              ediConfig.SingleJobAmount || '--') }}</span>，一个客户单月不超过<span style="font-weight: bold;">￥{{ (ediConfig &&
                  ediConfig.MonthJobAmount || '--') }} </span>
              <a style="text-decoration:underline;font-weight: bold;cursor: pointer;margin-left: 10px;"
                @click="editEdiConfig">修改</a>
            </p>
          </slot>
        </el-alert>
      </el-row>
      <el-row class="customer-row-bg">
        <!-- <el-col :span="20" style="text-align: left; display: flex; align-items: center">
          <div style="padding: 5px;">
            <el-alert
              title="带辅助性文字介绍"
              :closable="false"
              type="warning"
              description="这是一句绕口令：黑灰化肥会挥发发灰黑化肥挥发；灰黑化肥会挥发发黑灰化肥发挥。 黑灰化肥会挥发发灰黑化肥黑灰挥发化为灰……">
            </el-alert>
        </div>
        </el-col> -->
        <el-col :span="20" style="text-align: left; display: flex; align-items: center">
          <el-form :inline="true" label-width="100px" label-position="left">
            <el-form-item label="发单企业Id:">
              <el-input v-model="form.CompanyId" placeholder="发单企业Id"></el-input>

            </el-form-item>
            <el-form-item label="发单企业名称:">
              <el-input v-model.trim="form.CompanyName" placeholder="发单企业名称"></el-input>
            </el-form-item>
            <el-form-item label="完成时间：">
              <!-- <el-input size="medium" style="width:150px;" v-model="form.spaperNo" placeholder="请输入考试编号" type="text" /> -->
              <el-date-picker size="" v-model="searchTime" type="daterange" format="yyyy-MM-dd"
                :picker-options="pickerOptions" value-format="yyyy-MM-dd" range-separator="—" start-placeholder="开始"
                end-placeholder="结束" style="width: 100%;"></el-date-picker>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="4">
          <el-form inline label-width="90px" label-position="left" style="text-align: right">
            <el-form-item>
              <el-button size="medium" type="primary" @click="handleSearch">查询</el-button>
            </el-form-item>
            <el-form-item>
              <el-button size="medium" type="success" @click="handleReset">重置</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </div>

    <!-- 列表 -->
    <el-table :stripe="true" :data="tableData" border style="width: 100%; margin-top: 20px" v-loading="listLoading"
      :header-cell-style="{ background: '#F5F7FA' }">
      <!-- eslint-disable  -->
      <el-table-column label="工单ID" prop="0" show-overflow-tooltip width="80">
        <template slot-scope="scope">
          <span>{{ scope.row.JobId || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="工单编号" prop="0" show-overflow-tooltip width="130">
        <template slot-scope="scope">
          <span>{{ scope.row.JobNo || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="客户企业Id" show-overflow-tooltip width="100">
        <template slot-scope="scope">
          <span>{{ (scope.row.CompanyId ) || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="客户企业名称" show-overflow-tooltip width="200">
        <template slot-scope="scope">
          <span>{{ (scope.row.SendJobCompany ) || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="工单类别" show-overflow-tooltip width="80">
        <template slot-scope="scope">
          <span>{{ scope.row.Platform || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="工单标题" show-overflow-tooltip width="250">
        <template slot-scope="scope">
          <span>{{ scope.row.JobTitle || "--" }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="省份" show-overflow-tooltip width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.JobProvince || "--" }}</span>
        </template>
      </el-table-column> -->
    
      <el-table-column label="工单城市" show-overflow-tooltip width="120">
        <template slot-scope="scope">
          <span>{{ (scope.row.JobProvince +' - '+scope.row.JobCity) || "--" }}</span>
        </template>
      </el-table-column>

      <el-table-column label="所属销售" show-overflow-tooltip width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.SalesUserName || "--" }}</span>
        </template>
      </el-table-column>

      <el-table-column label="子公司" show-overflow-tooltip width="200">
        <template slot-scope="scope">
          <span>{{ scope.row.SaleCompanyName || "--" }}</span>
        </template>
      </el-table-column>

      <el-table-column label="结算费用" show-overflow-tooltip width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.SettlementAmount || "--" }}</span>
        </template>
      </el-table-column>

      <el-table-column label="客户累计" show-overflow-tooltip width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.TotalAmount || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="完成时间" show-overflow-tooltip width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.CompleteTime || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="标签" show-overflow-tooltip width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.JobTagName || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="是否推送" show-overflow-tooltip width="150">
        <template slot-scope="scope">
          <span>{{ (scope.row.IsPush ? "已推送" : "未推送") || "--" }}</span>
        </template>
      </el-table-column>
    </el-table>
    <div style="margin: 10px; overflow: hidden">
      <div style="float: right" v-show="tableData.length">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="form.PageNum" :page-sizes="[10, 20, 50, 100, 200]" :page-size="form.PageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>

    <!-- 修改阈值配置 -->
    <el-dialog title="修改阈值配置" :visible.sync="dialogShow" width="30%" :close-on-click-modal="false" ref="dialog"
      append-to-body>
      <el-form label-position="left" label-width="180px">
        <el-form-item label="单个工单最大金额：" required>
          <el-input v-model="formEdiConfig.SingleJobAmount" placeholder="单个工单最大金额"></el-input>
        </el-form-item>
        <el-form-item label="客户单月最大金额：" required>
          <el-input v-model="formEdiConfig.MonthJobAmount" placeholder="客户单月最大金额"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="submitEdiConfig">确 定</el-button>
      </span>
    </el-dialog>


  </div>
</template>
<script>
import {
  getEdiJobList, saveEdiJobConfig
} from "@/service/salesStatistics";

export default {
  data() {
    return {
      dialogShow: false,
      tipMsg: '',
      searchTime: '',
      listLoading: false,
      form: {
        PageNum: 1,
        PageSize: 10,
        IsDesc: true,
        CompanyId: "",
        CompanyName: "", //企业名称
        StartCompleteTime: "",
        EndCompleteTime: "",
      },
      total: 0, //总条数
      tableData: [],
      ediConfig: null,
      formEdiConfig: { SingleJobAmount: 0, MonthJobAmount: 0 },

      pickerOptions: {
        shortcuts: [{
          text: '当月',
          onClick(picker) {
            const now = new Date();
            var today = new Date(now.toLocaleDateString());

            var year = now.getFullYear();
            var month = now.getMonth() + 1;
            var str = year + '-' + month + "-1";
            var nmonth_first = new Date(str);

            picker.$emit('pick', [nmonth_first, today]);
          }
        }, {
          text: '当天',
          onClick(picker) {
            const now = new Date();
            var today = new Date(now.toLocaleDateString());

            // var year=now.getFullYear();
            // var month=now.getMonth()+1;
            // var str=year+'-'+month+"-1";
            // var nmonth_first=new Date(str);

            picker.$emit('pick', [today, today]);
          }
        }]
      },
      selectTab: "2",
      tabArray: [{
        key: 1,
        value: "众业达子公司客户全部工单",
      }, {
        key: 2,
        value: "SaaS/灵工工单",
      }],
    };
  },
  created() {
    this.initSearchTime();
    this.tableData = [];
    this.handleSearch();
  },
  activated() {
    this.initSearchTime();
  },
  methods: {
 initSearchTime() {
            const now = new Date();
            var today = new Date(now.toLocaleDateString());

            var year_today = today.getFullYear();
            var month_today = today.getMonth() + 1;
            var day_today = today.getDate();
            var today_str = year_today + '-' + month_today + '-' + day_today;
            console.log('today_str:' + today_str);

            var year = now.getFullYear();
            var month = now.getMonth() + 1;
            var start = year + '-' + month + "-1";
            console.log('start:' + start);
            var nmonth_first = new Date(start);
            // console.log('end 时间:' + nmonth_first);
            // this.searchTime = [nmonth_first, today];
            this.searchTime = [start, today_str];
        },
    // 查询
    handleSearch() {
      this.handleCurrentChange(1);
    },
    // 重置
    handleReset() {
      this.form.CompanyId = "";
      this.form.CompanyName = "";
      this.searchTime = '';
      this.form.StartCompleteTime = '';
      this.form.EndCompleteTime = '';
      this.handleSearch();
    },
    handleSizeChange(val) {
      if (this.listLoading) return;
      this.form.PageNum = 1;
      this.form.PageSize = val;
      this.GetEdiJobData();
    },
    handleCurrentChange(val) {
      if (this.listLoading) return;
      this.form.PageNum = val;
      this.GetEdiJobData();
    },
    //获取edi工单列表
    async GetEdiJobData() {
      this.listLoading = true;
      if (this.searchTime && this.searchTime.length) {
        this.form.StartCompleteTime = this.searchTime[0];
        this.form.EndCompleteTime = this.searchTime[1];
      }
      else {
        this.form.StartCompleteTime = "";
        this.form.EndCompleteTime = "";
      }
      let data = {
        CompanyId: 0,
        PageNum: this.form.PageNum,
        PageSize: this.form.PageSize,
      };
      if (this.form.CompanyId != "") data.CompanyId = this.form.CompanyId;
      if (this.form.CompanyName != "") data.CompanyName = this.form.CompanyName;
      if (this.form.StartCompleteTime != "") data.StartCompleteTime = this.form.StartCompleteTime;
      if (this.form.EndCompleteTime != "") data.EndCompleteTime = this.form.EndCompleteTime;


      console.log("data:" + JSON.stringify(data));

      let res = await getEdiJobList(data);
      this.listLoading = false;
      if (res.Result != 1) {
        return this.$message.error("获取失败请联系开发人员");
      }
      this.tableData = res.Data.JobList;
      this.total = res.Data.TotalCount;
      this.ediConfig = res.Data.EdiConfig;
    },

    //修改
    editEdiConfig() {
      this.dialogShow = true;
      this.formEdiConfig = { ...this.ediConfig };
    },
    //提交阈值配置
    async submitEdiConfig() {
      console.log('submitEdiConfig:' + JSON.stringify(this.formEdiConfig))
      if (isNaN(this.formEdiConfig.SingleJobAmount)) {
        return this.$message.error('单个工单最大金额请输入数字');
      }
      if (isNaN(this.formEdiConfig.MonthJobAmount)) {
        return this.$message.error('客户单月最大金额请输入数字');
      }

      if (this.formEdiConfig.MonthJobAmount < this.formEdiConfig.SingleJobAmount) {
        return this.$message.error('[客户单月最大金额]不能小于[单个工单最大金额]');
      }
      let res = await saveEdiJobConfig(this.formEdiConfig);
      if (res.Result != 1) {
        return this.$message.error(res.Message);
      }
      this.$message({ message: res.Message, type: "success" });
      this.dialogShow = false;
      this.GetEdiJobData();
    },
    //切换tab之前
    tabSelect(activeName, oldActiveName) {
      console.log('activeName:' + activeName + ";oldActiveName:" + oldActiveName);
      if (activeName == "2") {
        return true;
      }
      else {
        this.$router.push('zydJobList');
        console.log(1111);
        return false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.customer-list {
  position: relative;

  .next-button {
    position: absolute;
    right: 0;
    top: -56px;
  }
}

.customer-row-bg {
  padding: 20px 14px;
  background-color: #f9fafc;
  display: flex;
  align-items: center;

  .el-form-item {
    margin-bottom: 0 !important;
  }

  .selected {
    color: #409eff;
    border-color: #c6e2ff;
    background-color: #ecf5ff;
  }
}
</style>